<div class="mt-3">
    <app-list entityName="PpeHistory" module="MovimientoBienes"
        [defaultQuery]="[{column: 'idActivo', value: id},{column: 'value', value: ['0']} ]">
    </app-list>
</div>